
define('text!views/templates.html',[],function () { return '<section>\r\n    <iframe\r\n        style="position: absolute; left: 0; right: 0; bottom: 0; top: 0; min-height: 95%; height: calc(100%);width: 100%;"\r\n        data-bind="attr: {src: iframeUrl}"></iframe>\r\n</section>';});

